import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

interface AdvtData {
  advt_count: number;
  booking_no: string;
  name: string;
  cust_name: string;
  DS_advtsize: string;
  instruction: string;
  pages_no: number;
  net_amt: any;
  saved_by: string | null;  // ✅ Add this
  booking_date?: string;
  rep_name?: string;
  off_rep_name?: string;
  DS_ISSUENAME?: string;
  DS_ISSUEDATE?: string;
  isSelected?: boolean;
}

interface GroupedAdvtData {
  isSelected: boolean;
  advt_size: string;
  advt_data: AdvtData[];
  total_count: number;
  total_pages: number;
}

interface SummaryData {
  advtsize: string;
  total: number;
  totalPane: number;
}

@Component({
  selector: 'app-prasiddhipatrak',
  templateUrl: './prasiddhipatrak.component.html',
  styleUrls: ['./prasiddhipatrak.component.scss'],
})
export class PrasiddhipatrakComponent implements OnInit {
  today = new Date();
  start_date = '';
  end_date = '';
  advt_name = '';
  rep_name = '';
  off_rep_name = '';
  issue_category = '';
  issue_dates = '';
  issue_date;
  issue_name;
  prasiddhipatrakData: GroupedAdvtData[] = [];
  filteredprasiddhipatrakData = [];
  prasiddhipatrak = [];
  prasiddhipatraksummary: SummaryData[] = [];
  value;
  value1;
  total_count: number = 0;
  total_page: number = 0;
  ppissuedate: any;
  ppissuename: string;
  issuenamenew: any;
  issuedatepp: any;
  cust_name: any;
  AdvtData: any;
  total_advt;
  multicolorcount = 0;
  multicolorpanetotal = 0;
  bandwpanetotal = 0;
  valueT: any;

  constructor(
    private dialogref: MatDialogRef<PrasiddhipatrakComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    debugger;
    this.issuenamenew = this.data['issuenamenew'];
    this.issuedatepp = this.data['issuedatepp'];
    this.start_date = this.data['start_date'];
    this.issue_name = this.data['issue_name'];
    this.end_date = this.data['end_date'];
    this.cust_name = this.data['cust_name'];
    this.advt_name = this.data['advt_name'] === '' ? '' : this.data['advt_name'];
    this.rep_name = this.data['rep_name'] === '' ? '' : this.data['rep_name'];
    this.off_rep_name = this.data['off_rep_name'] === '' ? '' : this.data['off_rep_name'];
    this.issue_category = this.data['issue_category'] === undefined ? '' : this.data['issue_category'];
    this.issue_dates = this.data['issue_date'];
    this.value = this.data['val'];
    this.value1 = this.data['val1'];
    this.valueT = this.data['value'];



    this.ppissuename = this.issue_dates[0].split(',')[1];
    this.ppissuedate = this.issue_dates[0].split(',')[0];

    this.issue_date = this.data['issue_date'] + '';
    console.log(this.issue_date.split(','));
    this.issue_name = this.issue_date.split(',')[0] == 'all' ? this.issue_date.split(',')[2] : this.issue_date.split(',')[1];
    this.issue_date = this.issue_date.split(',')[0] == 'all' ? this.issue_date.split(',')[1] : this.issue_date.split(',')[0];

    this.today = new Date();
    this.getPrasiddhiPatrakData(this.value, this.value1);
  }

  getPrasiddhiPatrakData(val, val1) {
    const req = {
      'value': val,
      'value1': val1,
      'valueT': this.valueT,
      'issue_name': this.issue_category,
      'issue_date': this.issue_dates,
      'start_date': this.start_date,
      'end_date': this.end_date,
      'advt_name': this.advt_name,
      'rep_name': this.rep_name,
      'off_rep_name': this.off_rep_name,
      'cust_name': this.cust_name,
    };

    this.service.getPrasiddhiPatrakData(req).subscribe((data) => {

      this.prasiddhipatrakData = data.map(group => ({
        ...group,
        isSelected: true,
        advt_data: group.advt_data.map(item => ({
          ...item,
          // ✅ saved_by = null → empty checkbox, saved_by = "admin" → ticked
          isSelected: item.saved_by !== null && item.saved_by !== undefined && item.saved_by !== ''
        }))
      }));

      // ✅ Header checkbox ticked only if ALL rows are ticked
      this.selectAll = this.prasiddhipatrakData.every(group =>
        group.advt_data.every(item => item.isSelected)
      );

      console.log('DATA WITH CHECKBOX:', this.prasiddhipatrakData);

      this.filtersData();
      setTimeout(() => {
        this.getData();
        this.calculateAllTotalsFromGroupedData();
      }, 200);
    });
  }

  // Optimized calculation method that works with your existing data structure
  calculateAllTotalsFromGroupedData(): void {
    this.total_count = 0;
    this.total_page = 0;
    this.multicolorcount = 0;
    this.multicolorpanetotal = 0;
    this.bandwpanetotal = 0;

    // Reset summary array
    this.prasiddhipatraksummary = [];

    this.prasiddhipatrakData.forEach(group => {
      // Calculate totals for each group
      group.total_count = group.advt_data.length;
      group.total_pages = 0;

      // Calculate pages for this group
      group.advt_data.forEach(item => {
        group.total_pages += parseInt(item.pages_no?.toString() || '0');
      });

      // Add to overall totals
      this.total_count += group.total_count;
      this.total_page += group.total_pages;

      // Create summary entry for this group
      const summaryEntry: SummaryData = {
        advtsize: group.advt_size,
        total: group.total_count,
        totalPane: this.calculatePaneValue(group.advt_size, group.total_count)
      };

      this.prasiddhipatraksummary.push(summaryEntry);

      // Calculate color vs B&W pages
      if (group.advt_size.indexOf('Multicolour') > -1) {
        this.multicolorcount++;
        this.multicolorpanetotal += summaryEntry.totalPane;
      } else {
        this.bandwpanetotal += summaryEntry.totalPane;
      }
    });

    console.log('Total Count:', this.total_count);
    console.log('Total Pages:', this.total_page);
    console.log('Summary:', this.prasiddhipatraksummary);
  }

  // Helper method to calculate pane values based on advertisement size
  calculatePaneValue(advtSize: string, count: number): number {
    if (advtSize.indexOf('Multicolour') > -1) {
      return count;
    } else if (advtSize.indexOf('B & W- Quarter Page') > -1) {
      return 0.25 * count;
    } else if (advtSize.indexOf('B & W- Half Page') > -1) {
      return 0.5 * count;
    } else if (advtSize.indexOf('B & W- full Page') > -1) {
      return count;
    } else if (advtSize.indexOf('B & W- 6 x 8.3 Cms') > -1 || advtSize.indexOf('B & W- 5 x 8.3 Cms') > -1) {
      return 0.125 * count;
    } else if (advtSize.indexOf('B & W- 5 x 5.5 Cms') > -1 || advtSize.indexOf('B & W- 4 x 5.5 Cms') > -1) {
      return 0.833 * count;
    }
    return count; // Default case
  }

  // Optimized filtering method using dynamic filter building
  filtersData() {
    this.filteredprasiddhipatrakData = this.prasiddhipatrakData.filter((item) => {
      let matches = true;

      // Date range filter
      if (this.start_date && this.end_date) {
        matches = matches && (item['booking_date'] >= this.start_date && item['booking_date'] <= this.end_date);
      }

      // Advertiser name filter
      if (this.advt_name) {
        matches = matches && this.advt_name.includes(item['name']);
      }

      // Rep name filter
      if (this.rep_name) {
        matches = matches && this.rep_name.includes(item['rep_name']);
      }

      // Office rep name filter
      if (this.off_rep_name) {
        matches = matches && this.off_rep_name.includes(item['off_rep_name']);
      }

      // Issue category filter
      if (this.issue_category) {
        matches = matches && (item['DS_ISSUENAME'] === this.issue_category);
      }

      // Issue dates filter
      if (this.issue_dates) {
        matches = matches && this.issue_dates.includes(item['DS_ISSUEDATE']);
      }

      return matches;
    });
  }

  getData() {
    let data = this.uniqueId(this.filteredprasiddhipatrakData, (a) => a.DS_advtsize);

    this.total_advt = 0;
    this.multicolorcount = 0;
    this.multicolorpanetotal = 0;
    this.bandwpanetotal = 0;

    // Clear existing arrays
    this.prasiddhipatrak = [];
    this.prasiddhipatraksummary = [];

    for (let index = 0; index < data.length; index++) {
      let arr = this.filteredprasiddhipatrakData.filter(
        (a) => data[index]['DS_advtsize'] === a['DS_advtsize']
      );

      let prasiddhi = {
        total: 0,
        advtsize: '',
      };

      let prasiddhipatraksumary: SummaryData = {
        advtsize: '',
        total: 0,
        totalPane: 0,
      };

      this.total_advt += arr.length;
      prasiddhi.total = arr.length;
      prasiddhipatraksumary.total = arr.length;

      // Calculate pane value using the helper method
      prasiddhipatraksumary.totalPane = this.calculatePaneValue(arr[0]['DS_advtsize'], arr.length);

      prasiddhi.advtsize = arr[0]['DS_advtsize'];
      prasiddhipatraksumary.advtsize = arr[0]['DS_advtsize'];
      arr.push(prasiddhi);
      this.prasiddhipatrak.push(arr);
      this.prasiddhipatraksummary.push(prasiddhipatraksumary);
    }

    // Calculate color and B&W totals
    for (let j = 0; j < this.prasiddhipatraksummary.length; j++) {
      if (this.prasiddhipatraksummary[j]['advtsize'].indexOf('Multicolour') > -1) {
        this.multicolorcount++;
        this.multicolorpanetotal += parseFloat(this.prasiddhipatraksummary[j]['totalPane'].toString());
      } else {
        this.bandwpanetotal += parseFloat(this.prasiddhipatraksummary[j]['totalPane'].toString());
      }
    }
  }

  uniqueId(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  // Method to get advertisement size statistics
  getAdvtSizeStats(): { [key: string]: { count: number; pages: number; percentage: number } } {
    const stats: { [key: string]: { count: number; pages: number; percentage: number } } = {};

    this.prasiddhipatraksummary.forEach(item => {
      stats[item.advtsize] = {
        count: item.total,
        pages: item.totalPane,
        percentage: this.total_count > 0 ? (item.total / this.total_count) * 100 : 0
      };
    });

    return stats;
  }

  // Method to get color vs B&W statistics
  getColorStats(): { multicolor: number; bandw: number; totalPages: number } {
    return {
      multicolor: this.multicolorpanetotal,
      bandw: this.bandwpanetotal,
      totalPages: this.multicolorpanetotal + this.bandwpanetotal
    };
  }

  // Method to get overall statistics
  getOverallStats(): {
    totalAdvertisements: number;
    totalPages: number;
    totalSizes: number;
    averagePagesPerAd: number;
    colorPagePercentage: number;
    bandwPagePercentage: number;
  } {
    const totalPages = this.multicolorpanetotal + this.bandwpanetotal;
    return {
      totalAdvertisements: this.total_count,
      totalPages: this.total_page,
      totalSizes: this.prasiddhipatraksummary.length,
      averagePagesPerAd: this.total_count > 0 ? this.total_page / this.total_count : 0,
      colorPagePercentage: totalPages > 0 ? (this.multicolorpanetotal / totalPages) * 100 : 0,
      bandwPagePercentage: totalPages > 0 ? (this.bandwpanetotal / totalPages) * 100 : 0
    };
  }

  // Method to export summary data
  getSummaryForExport(): any[] {
    return this.prasiddhipatraksummary.map((item, index) => ({
      serialNo: index + 1,
      advtSize: item.advtsize,
      count: item.total,
      totalPages: item.totalPane,
      type: item.advtsize.indexOf('Multicolour') > -1 ? 'Color' : 'B&W'
    }));
  }

  print() {
    const originalTitle = document.title;

    const style = document.createElement('style');
    style.innerHTML = `
    @media print {
      @page {
        size: A4;
        margin: 15mm 8mm;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      body {
        background: white !important;
        margin: 0 !important;
        padding: 0 !important;
        font-size: 12px !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .container {
        max-width: none !important;
        margin: 0 !important;
        padding: 5px !important;
        background: white !important;
        box-shadow: none !important;
        border-radius: 0 !important;
      }

      /* Hide controls */
      .print-controls, .noPrint, button, .no-print {
        display: none !important;
      }

      /* Header Table - preserve colors */
      .header-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 10px;
        font-weight: bold;
        page-break-inside: avoid;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .header-table th,
      .header-table td {
        border: 2px solid #000 !important;
        padding: 6px !important;
        text-align: center;
        vertical-align: middle;
        font-size: 12px !important;
        line-height: 1.1;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .header-table th {
        background-color: #f8f9fa !important;
        font-size: 14px !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      /* Data Section - preserve all styling */
      .data-section {
        border: 2px solid #000 !important;
        margin-bottom: 20px;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .data-row {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #000 !important;
        min-height: 30px;
        page-break-inside: avoid;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .data-row:last-child {
        border-bottom: none !important;
      }

      .data-cell {
        padding: 3px 2px !important;
        text-align: left;
        border-right: 1px solid #000 !important;
        font-size: 11px !important;
        word-wrap: break-word;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1.3;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .data-cell:last-child {
        border-right: none !important;
      }

      /* Column Widths - maintain original layout */
      .col-serial { width: 8% !important; }
      .col-booking { width: 12% !important; }
      .col-advertiser { width: 30% !important; }
      .col-customer { width: 15% !important; }
      .col-size { width: 25% !important; }
      .col-instruction { width: 10% !important; }
      .col-page { width: 10% !important; }

      /* Force left alignment for advertiser column */
      .col-advertiser {
        justify-content: flex-start !important;
        text-align: left !important;
        padding-left: 4px !important;
      }

      .data-cell.center {
        text-align: center !important;
        justify-content: center !important;
      }

      .data-cell.right {
        text-align: right !important;
        justify-content: flex-end !important;
      }

      /* Header Row - preserve background color */
      .header-row {
        background-color: #f8f9fa !important;
        font-weight: bold !important;
        border-bottom: 2px solid #000 !important;
        font-size: 14px !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .header-row .data-cell {
        text-align: center !important;
        justify-content: center !important;
        background-color: #f8f9fa !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      /* Group Header - preserve background color */
      .group-header {
        background-color: #e9ecef !important;
        font-weight: bold !important;
        page-break-after: avoid;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .group-header div {
        width: 100%;
        padding: 4px !important;
        text-align: left;
        font-size: 12px !important;
        background-color: #e9ecef !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      /* Subtotal and Total Rows - preserve background colors */
      .subtotal-row,
      .total-row {
        background-color: #f8f9fa !important;
        font-weight: bold !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .subtotal-row div,
      .total-row div {
        padding: 4px !important;
        font-size: 14px !important;
        background-color: #f8f9fa !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      /* Summary Table - preserve styling */
    
.signature-section {
  position: relative !important;   /* Not fixed anymore */
  bottom: auto !important;
  left: auto !important;
  right: auto !important;
  width: 100% !important;
  margin-top: 40px !important;      /* Some spacing above */
  page-break-inside: avoid !important;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
}


.signature-container {
  width: 100% !important;
  display: flex !important;
  justify-content: space-between !important;
  margin-top: 40px !important;
}

.signature-box {
  width: 30% !important;
  text-align: left !important;   /* ⬅ Left aligned */
  border-top: 1px solid #000 !important;
  padding-top: 5px !important;
  font-size: 14px !important;
  font-weight: bold !important;
}



.signature-table-bottom td {
  border: 1px solid #000 !important;
  padding: 15px 8px 5px 8px !important;
  text-align: left !important;   /* ✅ Left aligned now */
  font-size: 12px !important;
  font-weight: bold !important;
  height: 30px !important;
  vertical-align: bottom !important;
  width: 33.33% !important;
}

/* Alternative table-based signature layout */
.signature-table-final {
  width: 100% !important;
  border-collapse: collapse !important;
  text-align: left !important; 
  margin-top: 30px !important;
  page-break-inside: avoid !important;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
}

.report-container {
    display: flex !important;
    flex-direction: column !important;
    min-height: 100vh !important; /* Full page height */
  }

  .content-wrapper {
    flex: 1 !important; /* Take remaining space */
  }

  .signature-section {
    margin-top: auto !important;   /* Push to bottom */
    page-break-inside: avoid !important;
  }

.signature-table-final td {
  border: 1px solid #000 !important;
  padding: 15px 8px 5px 8px !important;
  text-align: left !important; 
  font-size: 14px !important;
  font-weight: bold !important;
  height: 40px !important;
  vertical-align: bottom !important;
}

/* Remove the previous signature CSS and use this instead */

/* Main content wrapper */
.print-container {
  min-height: calc(100vh - 40mm) !important;
  display: flex !important;
  flex-direction: column !important;
}

.content-area {
  flex: 1 !important;
}

/* Signature pushed to bottom */
.signature-section {
  margin-top: auto !important;
  margin-bottom: 0 !important;
  text-align: left !important;
  page-break-inside: avoid !important;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
}

.signature-table-bottom {
  width: 100% !important;
  border-collapse: collapse !important;
  text-align: left !important;
  margin-top: 20px !important;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
}

.signature-table-bottom td {
  border: 1px solid #000 !important;
  padding: 15px 8px 5px 8px !important;
  text-align: left !important;
  font-size: 14px !important;
  font-weight: bold !important;
  height: 30px !important;
  vertical-align: bottom !important;
  width: 33.33% !important;
}

      /* Data table styling - if using table elements */
      .data-table {
        width: 100% !important;
        border-collapse: collapse !important;
        page-break-inside: auto;
        margin-bottom: 15px !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .data-table th, .data-table td {
        border: 1px solid #000 !important;
        padding: 3px !important;
        font-size: 11px !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      /* Repeat header */
      .data-table thead {
        display: table-header-group !important;
      }

      /* Size/remarks section */
      .size-table {
        width: 100% !important;
        margin-top: 20px !important;
        border-collapse: collapse !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .size-table td {
        border: 1px solid #000 !important;
        padding: 6px !important;
        font-size: 11px !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      /* Totals table */
      .totals-table {
        width: 100% !important;
        border-collapse: collapse !important;
        margin-top: 15px !important;
        page-break-before: auto;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      .totals-table td {
        border: 1px solid #000 !important;
        padding: 5px !important;
        font-size: 12px !important;
        font-weight: bold !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }

      /* Page break controls */
      .page-break-before {
        page-break-before: always !important;
      }

      .page-break-after {
        page-break-after: always !important;
      }

      .no-page-break {
        page-break-inside: avoid !important;
      }
    }
  `;

    document.head.appendChild(style);

    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) {
        printTrigger.click();
      }

      document.title = originalTitle;

      setTimeout(() => {
        document.head.removeChild(style);
      }, 1000);
    }, 500);
  }





  // Additional helper methods for your existing functionality
  calculateGroupTotals(): void {
    this.prasiddhipatrakData.forEach(group => {
      group.total_count = group.advt_data.length;
      group.total_pages = group.advt_data.reduce((sum, item) => {
        return sum + (parseInt(item.pages_no?.toString() || '0'));
      }, 0);
    });
  }

  calculateOverallTotals(): void {
    this.total_count = this.prasiddhipatrakData.reduce((sum, group) => {
      return sum + group.total_count;
    }, 0);

    this.total_page = this.prasiddhipatrakData.reduce((sum, group) => {
      return sum + group.total_pages;
    }, 0);
  }

  generateSummaryData(): void {
    this.prasiddhipatraksummary = this.prasiddhipatrakData.map(group => ({
      advtsize: group.advt_size,
      total: group.total_count,
      totalPane: this.calculatePaneValue(group.advt_size, group.total_count)
    }));
  }

  calculateColorPages(): void {
    this.multicolorcount = 0;
    this.multicolorpanetotal = 0;

    this.prasiddhipatraksummary.forEach(item => {
      if (item.advtsize.indexOf('Multicolour') > -1) {
        this.multicolorcount++;
        this.multicolorpanetotal += item.totalPane;
      }
    });
  }

  recalculateAllTotals(): void {
    this.calculateGroupTotals();
    this.calculateOverallTotals();
    this.generateSummaryData();
    this.calculateColorPages();
  }



  selectedAdvtSizes: any[] = [];

  selectAll: boolean = false;

  onSelectAll(event: any): void {
  this.selectAll = event.target.checked;
  this.prasiddhipatrakData.forEach(group => {
    group.isSelected = this.selectAll;
    group.advt_data.forEach(item => {
      item.isSelected = this.selectAll;
    });
  });
}

onItemCheckChange(): void {
  // ✅ Sync header checkbox with all rows
  this.selectAll = this.prasiddhipatrakData.every(group =>
    group.advt_data.every(item => item.isSelected)
  );
}

getSelectedRows(): AdvtData[] {
  const selected: AdvtData[] = [];
  this.prasiddhipatrakData.forEach(group => {
    group.advt_data.forEach(item => {
      if (item.isSelected) selected.push(item);
    });
  });
  return selected;
}
}